import { motion } from 'framer-motion'
import { StyleText } from '@pages/front/commons/Text/style'
import {
  StyleCopywriteWrapper,
  StyleFooterWrapper,
  StyleImage,
  StyleLogoWrapper,
} from './style'
import logo from './logo.png'
import FooterLinkSection from './FooterLinkSection'
import FooterQuickLoginSection from './FooterQuickLoginSection'
import FooterGetInTouchSection from './FooterGetInTouchSection'
import { StyleSvgWrappeer } from '@pages/front/commons/SvgIcon/style'
import { PartialLogo } from '@pages/front/svgs/svg'

// Motion wrappers
const MotionFooterWrapper = motion(StyleFooterWrapper)
const MotionCopywriteWrapper = motion(StyleCopywriteWrapper)
const MotionLogoWrapper = motion(StyleLogoWrapper)

const Footer = () => {
  return (
    <>
      <MotionFooterWrapper
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        viewport={{ once: true, amount: 0.3 }}
      >
        <MotionLogoWrapper
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ delay: 0.2, duration: 0.6 }}
          viewport={{ once: true, amount: 0.3 }}
        >
          <StyleImage src={logo} />
          <StyleText
            textWidth="400"
            color="#414146"
            centered
            style={{ marginTop: '20px' }}
          >
            Book doctor appointments, lab tests, order medicines, and access
            healthcare services across Nepal — all in one app. Download Supchar
            today for instant care!
          </StyleText>
        </MotionLogoWrapper>

        <FooterLinkSection />
        <FooterQuickLoginSection />
        <FooterGetInTouchSection />
      </MotionFooterWrapper>

      <MotionCopywriteWrapper
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.4, duration: 0.5 }}
        viewport={{ once: true, amount: 0.3 }}
      >
        <StyleSvgWrappeer dangerouslySetInnerHTML={{ __html: PartialLogo }} />
        <StyleText color="#414146" centered>
          © 2025. All Rights Reserved by Supchar
        </StyleText>
      </MotionCopywriteWrapper>
    </>
  )
}

export default Footer
